/**
 * A route of this app, or null: only a path that starts with one "/" (the hash route, query included).
 * Rejected: absolute and protocol-relative URLs ("https://…", "//host"), schemes ("javascript:"),
 * backslashes and control characters -- so neither a manipulated address bar nor an OAuth state can send
 * the browser anywhere else (no open redirect). VTK-3611.
 */
export function safeReturnPath(value: string | null | undefined): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
  if (/[\\\u0000-\u001f\u007f]/.test(value)) return null;
  return value;
}
